<template>
  <div class="booxVersions-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span v-if="$route.query.id">编辑</span>
        <span v-else>新增</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'booxVersions' })"
        >
          {{ $t('commonMsg.back') }}
        </button>
        <button class="global-button-style" @click="save('ruleForm')">
          {{ $t('commonMsg.save') }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="100px"
          @submit.native.prevent
          :model="formData"
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item label="包名" prop="package">
            <el-input v-model="formData.package"></el-input>
          </el-form-item>
          <el-form-item label="选择apk" prop="select">
            <el-select
              v-model="currentVersion"
              placeholder="选填"
              clearable
              filterable
              @change="selectApk"
            >
              <el-option
                v-for="item in apkList"
                :key="item._id"
                :label="item.title"
                :value="item.version"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="版本号" prop="version">
            <el-input v-model="formData.version"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-radio-group v-model="formData.type">
              <el-radio v-for="item in typeData" :key="item" :label="item">{{
                item
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否强制更新" prop="force">
            <el-radio-group
              v-if="formData.type !== 'ios'"
              v-model="formData.force"
            >
              <el-radio
                v-for="item in forceData"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
            <el-radio-group v-else v-model="formData.force">
              <el-radio
                v-for="item in forceIOSData"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="链接" prop="url">
            <el-input v-model="formData.url"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input
              type="textarea"
              :rows="6"
              v-model="formData.description"
              @keydown.enter.exact.prevent.native="handleLine"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      apkList: [],
      currentVersion: '',
      formData: {
        package: '',
        version: '',
        force: 0,
        type: 'android',
        url: '',
        description: ''
      },
      forceData: [
        {
          value: 0,
          label: '否'
        },
        {
          value: 1,
          label: '是'
        }
      ],
      forceIOSData: [
        {
          value: 0,
          label: '否'
        },
        {
          value: 1,
          label: '是'
        },
        {
          value: 2,
          label: '手动更新'
        }
      ],
      typeData: ['android', 'ios'],
      params: {},
      modelData: [],
      rules: {
        package: [{ required: true, message: '不能为空', trigger: 'change' }],
        version: [{ required: true, message: '不能为空', trigger: 'change' }],
        url: [{ required: true, message: '不能为空', trigger: 'change' }]
      }
    }
  },
  methods: {
    handleLine() {
      this.formData.description += '\n'
    },
    getBooxVersionsDetails() {
      this.$http.getBooxVersionsDetails(this.$route.query.id).then((res) => {
        this.formData = Object.assign(this.formData, res.data)
        // this.currentVersion = this.formData.version;
      })
    },

    save(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.params = Object.assign({}, this.formData)
          if (this.$route.query.id) {
            this.edit()
          } else {
            this.create()
          }
        } else {
          return false
        }
      })
    },

    create() {
      this.$http.createBooxVersions(this.params).then((res) => {
        this.elMsg('创建成功', 'success')
        this.$router.push({ name: 'booxVersions' })
      })
    },

    edit() {
      this.$http
        .updateBooxVersions(this.$route.query.id, this.params)
        .then((res) => {
          this.elMsg('编辑成功', 'success')
          this.$router.push({ name: 'booxVersions' })
        })
    },
    async getApkList() {
      return new Promise(async (resolve, reject) => {
        let res = await this.$http.getBooxApp({
          limit: 10000,
          sortBy: 'updatedAt'
        })
        this.apkList = res.data.results
        resolve('ok')
      })
    },

    selectApk() {
      let currentApk = this.apkList.find(
        (item) => item.version === this.currentVersion
      )
      this.formData.version =
        currentApk && currentApk.version ? currentApk.version : ''
      this.formData.type =
        currentApk && currentApk.type ? currentApk.type : 'android'
      this.formData.url =
        currentApk && currentApk.file ? currentApk.file.url : ''
    }
  },
  async mounted() {
    await this.getApkList()
    if (this.$route.query.id) {
      this.getBooxVersionsDetails()
    }
  }
}
</script>

<style lang="scss">
.booxVersions-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
    .pic {
      .pic-item {
        /* position: relative; */
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .global-button-style {
        width: 80px;
        height: 30px;
      }
      .booxVersions-edit-cover {
        position: relative;
        width: 200px;
        height: 300px;
        overflow: hidden;
        margin: 10px 0;
        border: 2px dashed #ccc;
        border-radius: 10px;
        &:hover {
          border-color: #bb745c;
        }
        > img {
          width: 100%;
          height: 100%;
        }
        > .booxVersions-edit-cover-icon {
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #bb745c;
        }
        > .booxVersions-edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.4);
            .booxVersions-edit-upload-btn {
              display: block;
            }
          }
          .booxVersions-edit-upload-btn {
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            text-align: center;
            line-height: 300px;
            > .el-upload--text {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .add-img {
        width: 70px;
        height: 40px;
        font-size: 22px;
        line-height: 43px;
        color: #fff;
        cursor: pointer;
        background-color: #bb745c;
      }
    }
  }
}
</style>
